import React from "react";
import { Button, ConfigProvider } from "antd";
import clsx from "clsx";

export default function BlueButton({ type, icon, children, onClick, href, className, ...props }) {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Button: {
                        colorPrimaryHover: "#1899FF",
                        colorPrimary: "#1890FF",
                    }
                },
                token: {
                    colorPrimary: "#1890FF",

                }
            }}
        >
            <Button
                href={href}
                type={type} icon={icon}
                onClick={onClick}
                className={clsx(type === "default" && "border-[#1890FF]  text-[#1890FF]", className)}
                {...props}
            >{children}
            </Button>
        </ConfigProvider>
    )
}